import Env from './api/env';
import { setOS, getOS } from './api/platform';
import Platform from './Platform';
import { Share } from './Share';
import Storage from './Storage';
import DeviceInfo from './DeviceInfo';
import Dimensions from './Dimensions';
import useDimensions from './Dimensions/hooks/useDimensions';
import Animated from './Animated';
import * as Localisation from './Localisation';
import Orientation from './Orientation';

export {
    Env,
    setOS,
    getOS,
    DeviceInfo,
    Platform,
    Share,
    Storage,
    Dimensions,
    Animated,
    useDimensions,
    Localisation,
    Orientation,
};
